<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Aguarde ...</p>
</ngx-spinner>

<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="card resultados-card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="card-title mb-0">
            <i class="feather icon-bar-chart-2 me-3"></i>
            &nbsp; &nbsp; Resultados do Programa
          </h4>
        </div>
        <div class="card-body">
          <div class="filters-section mb-4">
            <div class="row align-items-center mb-3">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="triagemSelect" class="form-label">Selecione o Programa</label>
                  <select class="form-select custom-select" id="triagemSelect" 
                          [(ngModel)]="selectedTriagem" 
                          (change)="onTriagemChange($event)">
                    <option *ngFor="let triagem of triagens" [value]="triagem.iD_TRIAGEM">
                      {{triagem.titulo}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-8 text-end">
                <div class="export-button-wrapper">
                  <button class="btn btn-primary export-btn" (click)="exportarRespostas()">
                    <i class="feather icon-download me-2"></i> Exportar Respostas
                  </button>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="search-box">
                  <i class="feather icon-search"></i>
                  <input type="text" class="form-control" 
                         [(ngModel)]="searchText" 
                         (input)="onSearch()"
                         placeholder="Pesquisar...">
                </div>
              </div>
              <div class="col-md-6 text-end">
                <div class="counters">
                  <span class="badge bg-teal me-2">
                    <i class="feather icon-search me-1"></i> 
                    {{filteredResults.length}} resultados
                  </span>
                  <span class="badge bg-teal-light">
                    <i class="feather icon-filter me-1"></i> 
                    {{searchText ? 'Filtrado' : 'Todos'}}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive resultados-table">
            <table class="table table-hover">
              <thead class="table-light">
                <tr>
                  <th class="col-2">Responsável</th>
                  <th class="col-2">Criança</th>
             
                  <th class="col-1">Sexo</th>
                  <th class="col-2">Etapa</th>
                  <th class="col-2">Módulo</th>
                  <th class="col-2">Atividade</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let resultado of filteredResults">
                  <td class="text-truncate">{{resultado.responsaveL_NOME}}</td>
                  <td class="text-truncate">{{resultado.nome}}</td>
              
                  <td>{{resultado.sexo}}</td>
                  <td class="text-truncate">{{resultado.atividadeCurrence?.etapa}}</td>
                  <td class="text-truncate">{{resultado.atividadeCurrence?.modulo}}</td>
                  <td class="text-truncate">{{resultado.atividadeCurrence?.atividade}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>